import { makeStyles } from '@material-ui/core';

const styles = makeStyles(() => ({
  bold: {
    fontFamily: 'Avenir Bold',
  },
}));

export default styles;
